"use client";
import cn from "@/utils/cn";

type BillingToggleProps = {
  isMonthly: boolean;
  setIsMonthly: (value: boolean) => void;
  className?: string;
};

const BillingToggle = ({
  isMonthly,
  setIsMonthly,
  className = "",
}: BillingToggleProps) => {
  const tabClass = (active: boolean) =>
    cn(
      "flex-1 rounded-[12px] px-4 py-2 text-[14px] font-medium leading-[120%] -tracking-[0.03em] transition-colors",
      active
        ? "bg-white text-kd-secondary-1 shadow-[0_2px_4px_-2px_rgba(0,0,0,0.15)]"
        : "text-[#96A5B8] hover:text-kd-secondary-1",
    );

  return (
    <div
      role="tablist"
      aria-label="Billing period"
      className={cn(
        "inline-flex w-full max-w-[240px] items-stretch rounded-[12px] bg-kd-grey-button p-1",
        className,
      )}
    >
      <button
        type="button"
        role="tab"
        aria-selected={isMonthly}
        onClick={() => setIsMonthly(true)}
        className={tabClass(isMonthly)}
      >
        Monthly
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={!isMonthly}
        onClick={() => setIsMonthly(false)}
        className={tabClass(!isMonthly)}
      >
        Annual
      </button>
    </div>
  );
};

export default BillingToggle;
